import axios from "axios";
import { API_BASE_PATH } from "../../environment";
import { toast } from "react-toastify";

const PROMOTION_BASE_URL = `${API_BASE_PATH}/promotions/`;

interface PromotionRequest {
  employee_id: string;
  designation_from: string;
  designation_to: string;
  promotion_date: string;
}

interface Employee {
  employee_id: string;
  username: string;
}

interface PromotionResponse {
  employee_id: string;
  designation_from: string;
  designation_to: string;
  promotion_date: string;
  employee: Employee;
}

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

export const createPromotion = async (
  token: string | null,
  data: PromotionRequest
): Promise<PromotionResponse | null> => {
  if (!token) {
    toast.error("Authentication token is missing");
    return null;
  }

  try {
    const formData = new URLSearchParams();
    formData.append("employee_id", data.employee_id);
    formData.append("designation_from", data.designation_from);
    formData.append("designation_to", data.designation_to);
    formData.append("promotion_date", data.promotion_date);

    const response = await axios.post<PromotionResponse>(
      PROMOTION_BASE_URL,
      formData,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success("Promotion created successfully");
    return response.data;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    return null;
  }
};
